import { Building2 } from 'lucide-react'
import { WorkspaceSettings, DeleteWorkspaceCard } from '@/components/workspace'
import { useWorkspace } from '@/contexts/WorkspaceContext'
import { Skeleton } from '@/components/ui/skeleton'

export function WorkspaceGeneralPage() {
    const { currentWorkspace, loading, error } = useWorkspace()

    if (loading) {
        return (
            <div className="p-6 md:p-8 w-full animate-fade-in">
                <div className="max-w-[800px] mx-auto">
                    <div className="mb-8">
                        <Skeleton className="h-8 w-48 mb-2" />
                        <Skeleton className="h-4 w-72" />
                    </div>
                    <Skeleton className="h-64 w-full" />
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="p-6 md:p-8 w-full animate-fade-in">
                <div className="max-w-[800px] mx-auto">
                    <div className="p-6 rounded-lg bg-destructive/10 text-destructive">
                        <h2 className="font-semibold mb-2">Error loading workspace</h2>
                        <p>{error}</p>
                    </div>
                </div>
            </div>
        )
    }

    if (!currentWorkspace) {
        return (
            <div className="p-6 md:p-8 w-full animate-fade-in">
                <div className="max-w-[800px] mx-auto">
                    <div className="text-center py-12">
                        <Building2 className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                        <h2 className="text-2xl font-bold mb-2">No Workspace Selected</h2>
                        <p className="app-page-subtitle">
                            Create a workspace or select one from the sidebar
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-6 md:p-8 w-full animate-fade-in">
            <div className="max-w-[800px] mx-auto space-y-8">
                {/* Header */}
                <div>
                    <h1 className="app-page-title mb-1">General Settings</h1>
                    <p className="app-page-subtitle">
                        Manage your workspace details and preferences
                    </p>
                </div>

                {/* Workspace Settings */}
                <WorkspaceSettings />

                {/* Danger Zone - Delete Workspace */}
                <DeleteWorkspaceCard />
            </div>
        </div>
    )
}
